import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from '../../services/user.service';
import { RequestsServices } from './../../services/requests.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'campaign',
  templateUrl: './campaign.component.html',
  encapsulation: ViewEncapsulation.None,
})

export class CampaignComponent implements OnInit {
  message = '';
  isLoading: boolean;
  campaign = [];

  constructor(
    private userService: UserService,
    private request: RequestsServices
  ) {}

  public downloadCampaign(camp): void {
    this.trackingEvent(camp, 'baixe-e-divulgue');
    window.open(camp.files.notEdited, '_blank');
  }

  private getCampaign(companyId): void {

    const filterObject: any = {
      where: {
        or: [
          { and: [ { companyId: null } ] },
          { companyId }
        ]
      },
      order: [ 'created_at DESC' ]
    };

    const createParameters = [{
      param: 'filter',
      value: JSON.stringify(filterObject)
    }];

    this.request.get({path: 'campaign_special', endPoint: '/', params: createParameters}).then((campaign) => {
      this.isLoading = false;
      if (campaign.length > 0) {
        this.campaign = campaign;
      }
    });
  }

  ngOnInit() {
    const companyAccount = this.userService.getLoggedAccount();
    const typeBusiness = this.userService.getTypeAccount();
    this.isLoading = true;
    if (typeBusiness === 'company' && companyAccount) {
      this.getCampaign(companyAccount.id);
    } else {
      this.message = 'Conta de empresa inválida';
    }
  }

  trackingEvent(campaign, btnType) {
    const category = 'admin:home';
    const action = `material-de-apoio:${campaign.title}`;
    const label = `btn:${btnType}`;

    (window as any).sendEvent(category, action, label);
  }
}

